<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="row">
              <div class="col-1">
                <router-link
                  class="btn btn-sm btn-outline-info"
                  :to="{ name: 'cat-escalas' }"
                >
                  <i class="fas fa-angle-double-left"></i>
                  Atras
                </router-link>
              </div>
              <div class="col-11">
                <div class="os-tabs-w">
                  <div class="os-tabs-controls os-tabs-complex text-right">
                    <ul class="nav nav-tabs">
                      <li class="nav-item">
                        <span aria-expanded="true" class="nav-link active"
                          ><small class="tab-value">FECHA DE CREACIÓN:</small
                          ><span class="tab-label" style="font-size: 18px">{{
                            current.fecha_creacion
                          }}</span></span
                        >
                      </li>
                      <li class="nav-item">
                        <span aria-expanded="true" class="nav-link active"
                          ><small class="tab-value">USUARIO:</small
                          ><span class="tab-label" style="font-size: 18px">{{
                            current.usuario
                          }}</span></span
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div
                  class="element-box"
                  style="
                    padding: 0.8rem;
                    margin-top: 0rem;
                    margin-bottom: 0.5rem;
                  "
                >
                  <h5 class="form-header">
                    <span v-if="current && current.id"
                      >Información de la campaña</span
                    >
                    <span v-if="!current.id">Nueva campaña</span>
                    <u>{{ current.numero }}</u>
                    &nbsp;
                    <span
                      v-if="current.fecha_inicio > fecha_actual"
                      class="badge badge-info"
                      >Campaña de oferta no ha entrado en vigencia</span
                    >
                    <span
                      v-if="
                        current.fecha_inicio <= fecha_actual &&
                          current.fecha_fin >= fecha_actual
                      "
                      class="badge badge-success"
                      >Campaña de oferta activa</span
                    >
                    <span
                      v-if="
                        current.fecha_fin && current.fecha_fin < fecha_actual
                      "
                      class="badge badge-danger"
                      >Campaña de oferta ha vencido</span
                    >
                  </h5>
                </div>
              </div>
              <div class="col-8" style="padding-right: 0px">
                <div
                  class="element-box"
                  style="padding: 1rem; margin-top: 0rem"
                  >
                  <small
                    v-if="current.errors && current.errors.detail"
                    class="form-text text-danger"
                    >{{ current.errors.detail }}</small
                  >
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.nombre,
                          }"
                          >Nombre Escala</label
                        >
                        <input
                          type="text"
                          :disabled="current.id"
                          class="form-control"
                          v-model="current.nombre"
                        />
                        <small
                          v-if="current.errors && current.errors.nombre"
                          class="form-text text-danger"
                          >{{ current.errors.nombre[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.fecha_inicio,
                          }"
                          >Fecha Inicio</label
                        >
                        <input v-show="!current.id && !cambiar_fecha_inicio || current.id && cambiar_fecha_inicio"
                          type="date"
                          :disabled="estadoCampana == 'activa' || estadoCampana == 'expirada'"
                          class="form-control"
                          v-model="current.fecha_inicio"
                          :min="fecha_minima_calendario"
                        />                       
                        <div  v-show="current.id && !cambiar_fecha_inicio" class="form-control" style="height: 37px; background-color: #e9ecef;">
                          <div class="row" style="height: 37px">
                            <div class="col-10  text-muted" style="font-size: 15px">
                              {{fecha_inicio_texto | moment("DD/MM/YYYY")}}
                            </div>                           
                            <div class="col-2 text-right" v-if="estadoCampana=='inactiva'">
                              <i class="far fa-calendar fa-lg icono-class"
                                @click="cambiarFechaInicio()"
                              ></i>
                            </div>
                          </div> 
                        </div>
                        <small
                          v-if="current.errors && current.errors.fecha_inicio"
                          class="form-text text-danger"
                          >{{ current.errors.fecha_inicio[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.fecha_fin,
                          }"
                          >Fecha Fín</label
                        >
                        <input v-show="!current.id && !cambiar_fecha_fin || current.id && cambiar_fecha_fin"
                          type="date"
                          :disabled="estadoCampana=='expirada'"
                          class="form-control"
                          v-model="current.fecha_fin"
                          :min="fecha_minima_calendario"
                        />
                        <div v-show="current.id && !cambiar_fecha_fin" class="px-2" style="height: 37px; background-color: #e9ecef;"> <!-- Se muestra la fecha en formato texto DD/MM/YYYY incluso en computadores en ingles. -->
                          <div class="row " style="height: 37px">
                            <div class="col-10 mt-2 text-muted" style="font-size:15px">
                              {{fecha_fin_texto | moment("DD/MM/YYYY")}}                            
                            </div>
                            <div class="col-2 mt-2 text-right" v-if="estadoCampana=='activa' || estadoCampana=='inactiva'">
                              <i class="far fa-calendar fa-lg icono-class"
                                @click="cambiarFechaFin()"
                              ></i>
                            </div>
                          </div>  
                        </div>
                        <small
                          v-if="current.errors && current.errors.fecha_fin"
                          class="form-text text-danger"
                          >{{ current.errors.fecha_fin[0] }}</small
                        >
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.tipo_oferta,
                          }"
                          >Tipo</label
                        >
                        <select
                          class="form-control"
                          autofocus="autofocus"
                          v-model="current.tipo_oferta"
                          :disabled="current.estado == 'B'"                          
                        >
                          <template v-for="tipo in tipoOfertas">
                            <option :value="tipo.value">{{ tipo.label }}</option>
                          </template>  
                        </select>
                        <small
                          v-if="current.errors && current.errors.tipo_oferta"
                          class="form-text text-danger"
                          >{{ current.errors.tipo_oferta[0] }}</small
                        >
                      </div>
                    </div>
                  </div>                                 
                  <button
                    v-if="!current.id"
                    @click="guardar()"
                    class="btn btn-success"
                  >
                    Guardar
                  </button>
                  <button
                    v-if="cambiar_fecha_inicio || cambiar_fecha_fin"
                    @click="actualizarFechaCampana()"
                    class="btn btn-success"
                  >
                    Actualizar fecha
                  </button>
                  <button @click="regresarFecha()" class="btn btn-danger"
                    v-if="cambiar_fecha_inicio || cambiar_fecha_fin"
                  >
                    Cancelar
                  </button>  
                </div>
                <div
                  class="element-box"
                  style="padding: 1rem; margin-top: 0rem"
                  v-if="current && current.id"
                  >
                  <div class="row">
                    <div class="col-12">
                      <ProductoSelectComponentV2 :current="currentDetalle" @onChangeProducto="obtenerPreciosProductos"/>
                    </div>
                    <div class="col-4">
                      <UnidadMedidaSelectComponent :current="currentDetalle" />
                    </div>
                    <div class="col-4">
                      <label
                        v-bind:class="{
                          'text-danger':
                            currentDetalle.errors.unidad_medida &&
                            currentDetalle.errors.unidad_medida.length > 0,
                        }"
                        >Precio</label
                      >
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="currentDetalle.precio"
                      />
                      <small
                        v-if="currentDetalle && currentDetalle.errors"
                        class="text-danger"
                        >{{ currentDetalle.errors.precio }}</small
                      >
                    </div>
                    <div class="col-4">
                      <label>Cantidad Minima</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="currentDetalle.cantidad_minima"
                      />
                      <small
                        v-if="currentDetalle && currentDetalle.errors"
                        class="text-danger"
                        >{{ currentDetalle.errors.cantidad_minima }}</small
                      >
                    </div>
                    
                    <!-- <div class="col-3 d-flex align-items-center">
                      //la función se ejecuta al cambiar el producto, inicialmente se utilizaba este botón
                      <button class="btn btn-md btn-info mr-1 w-90" @click="obtenerPreciosProductos()">
                        Calcular descuento &nbsp;
                        <i class="fas fa-poll"></i>
                      </button> 
                    </div> -->
                  
                    <br />

                    <div
                      v-if="isTiendaSelected === true"
                      class="btn btn-sm btn-dark btn-block"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-dark btn-block"
                        @click="obtenerProductoEnOfertas()"
                      >
                        <i class="fa fa-plus"></i>
                        Agregar Producto
                      </button>
                    </div>
                    <div
                      v-if="isTiendaSelected === false"
                      class="btn btn-sm btn-dark btn-block"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-dark btn-block"
                        @click="
                          errorsModals(
                            'No se pueden agregar productos, sin antes haber seleccionado una tienda'
                          )
                        "
                      >
                        <i class="fa fa-plus"></i>
                        Agregar Producto
                      </button>
                    </div>

                    <div class="table-responsive" v-if="current.id != null">
                      <br />
                      <table class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Producto</th>
                            <th class="text-center">UM</th>
                            <th class="text-center">Cantidad</th>
                            <th class="text-center">Precio</th>
                            <th class="text-center">Opciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="detalle in current.campanadeofertasproducto_set"
                            v-bind:key="detalle.id"
                          >
                            <td>
                              {{ detalle.producto.sku }} -{{
                                detalle.producto.nombre
                              }}
                            </td>
                            <td>
                              {{ detalle.unidad_medida.nombre }}
                            </td>

                            <td>
                              <span class="text-success">
                                {{ detalle.cantidad_minima }}</span
                              >
                            </td>

                            <td>
                              <span class="text-success">
                                {{ detalle.precio }}</span
                              >
                            </td>
                            <td class="text-center">
                              <button
                                class="btn btn-sm btn-danger mr-1"
                                type="button"
                                @click="deleteDetalle(detalle)"
                              >
                                <i class="fa fa-trash"></i>
                                Eliminar
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-------------------- END - Basic Table -------------------->
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="element-box">
                  <div class="row justify-content-end">
                    <div class="d-flex justify-content-end mb-2">
                      <div class="d-flex align-items-center mr-2 bg-light pr-1 rounded border">
                        <span class="mr-1 badge">Descuento</span>
                        <i class="fa fas fa-circle text-success"></i>
                      </div>
                      <div class="d-flex align-items-center bg-light pr-1 rounded border">
                        <span class="mr-1 badge">Aumento</span>
                        <i class="fa fas fa-circle text-danger"></i>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <table
                      v-if="current && current.id"
                      class="table table-bordered"
                    >
                      <thead>
                        <th class="text-center">Tienda</th>
                        <th class="text-center">
                          <br />
                          <label for="multiple">Seleccion <br> Multiple </label>
                          &nbsp;
                          <input
                            type="checkbox"
                            id="multiple"
                            class="form-control"
                            v-model="all_tiendas"
                            @change="agregarTodosTiendas()"
                          />
                        </th>
                        <th class="text-center">Descuento <br> de  <br>{{currentDetalle.producto.sku}}</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Seleccion Multiple</td>

                          <td class="text-center">
                            <input
                              type="checkbox"
                              class="form-control"
                              v-model="all_tiendas"
                              @change="agregarTodosTiendas()"
                            />
                          </td>
                        </tr>
                        <tr
                          v-for="det in current.tiendas_set"
                          :key="det.id"
                          :value="det.id"
                          v-show="det.codigo_postal==1"
                        >
                          <td>{{ det.nombre }}</td>
                          <td class="text-center">
                            <input
                              type="checkbox"
                              class="form-control"
                              @change="agregarDetalleTienda(det)"
                              v-model="det.seleccionada"
                            />
                          </td>
                          <td class="text-center" >
                            <span :class="getClaseDescuento(det.lista_precio)" v-if="currentDetalle.precio">
                              {{ calcularDescuento(det.lista_precio) }}
                              <i v-if="esAumento(det.lista_precio) === true" class="fa fas fa-circle text-danger"></i>
                              <i v-if="esAumento(det.lista_precio) === false" class="fa fas fa-circle text-success"></i>
                              <i v-if="esAumento(det.lista_precio) === null"></i>
                            </span>
                            <span v-else>
                              -
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";
import ProductoWithPopoverComponent from "@/components/commons/ProductoWithPopoverComponent";
import DynamicService from "@/services/commons/DynamicService";
import SalidaTrasladoService from "@/services/inventario/SalidaTrasladoService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";

export default {
  components: {
    TiendaSelectComponent,
    UnidadMedidaSelectComponent,
    ProductoWithPopoverComponent,
    ProductoSelectComponentV2,
  },

  data() {
    return {
      isTiendaSelected: false,
      isProductsAdded: false,
      productsDetailCount: 0,
      current: {
        fecha_creacion: "",
        fecha_fin: "",
        tipo: "-",
        errors: {
          tienda: "",
          fecha: "",
        },
        reqtrasladod_set: [],
      },
      fecha_actual: "",
      all_tiendas: "",
      unidades_medidas: [],
      productos: [],
      options: [],

      currentDetalle: {
        precio: 0,
        cantidad_minima: 0,
        unidad_medida: "",
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        errors: [],
      },
      precios_x_lista:{ 
          lista_2: 0,
          lista_15: 0,
          lista_19: 0,
      },
      precios_de_productos: [],
      isPreciosProductosCargados: false,
      descuento: 0,
      ofertas_en_comun: [],
      ofertasInfoText: "",
      fecha_inicio_texto: "",
      fecha_fin_texto: "",
      fecha_creacion_texto: "",
      tipoOfertas: [],
      cambiar_fecha_inicio:false,
      cambiar_fecha_fin:false,
    };
  },
  computed: {
    isCreating(){
      return !this.current.id;
    },
    estadoCampana(){     
      if(!this.fecha_actual || !this.current.fecha_inicio || !this.current.fecha_fin){
        return ""
      }

      const fActual = moment(this.fecha_actual)
      const fInicio = moment(this.current.fecha_inicio)
      const fFin = moment(this.current.fecha_fin)       

      if(fActual.isBefore(fInicio)   && fActual.isBefore(fFin)){   
        return "inactiva"
      } 

      if(fActual.isSameOrAfter(fInicio) && fActual.isSameOrBefore(fFin)){     
        return "activa"
      }  

      if(fActual.isAfter(fInicio) && fActual.isAfter(fFin) ){        
        return "expirada"
      }   
    },
    fecha_minima_calendario(){
      const fechaMoment = moment(this.fecha_actual)
      const fechaMasUnDia = fechaMoment.add(1,"days")
      const fechaFormateada = fechaMasUnDia.format("YYYY-MM-DD")     
    }
    
  },
  beforeMount(){
    let self = this;
    CommonService.fecha_actual().then((res) => {      
      self.fecha_actual = res.data.fecha_actual;
      self.fecha_actual = moment(self.fecha_actual, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );   
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
    self.getTipoOfertas();
  },
  mounted() {
   
  },
  methods: {
    /**
     * Funcion para disparar modal de errores variados.
     */
    errorsModals(error_message) {
      Notifications.alert.error("Advertencia", error_message);
    },

    /**
     * Contador de Productos en detalles, este método nos sirve para
     * todas las validaciones en donde sea necesario verificar la
     * existencia en el listado de estos.
     */
    productosAddedCounter() {
      if (this.current.campanadeofertasproducto_set.length > 0) {
        this.isProductsAdded = true;
        this.productsDetailCount = this.current.campanadeofertasproducto_set.length;
      } else {
        this.isProductsAdded = false;
        this.productsDetailCount = 0;
      }
    },

    /**
     * Método que nos valida si existe al menos una tienda seleccionada
     * en el array de las tiendas seleccionables
     */
    validarTiendaSeleccionada(tiendas_array) {
      if (!tiendas_array || !Array.isArray(tiendas_array)) {
        return false;
      }
      return tiendas_array.some((tienda) => tienda.seleccionada === true);
    },

    /**
     * Método que nos valida si todas las tiendas estan seleccionadas
     * en el array de las tiendas seleccionables
     */
    validarTodasLasTiendaSeleccionadas(tiendas_array) {
      if (!tiendas_array || !Array.isArray(tiendas_array)) {
        return false;
      }
      return tiendas_array.every((tienda) => tienda.seleccionada === true);
    },

    agregarDetalleTienda(item) {
      let self = this;
      if (
        self.isProductsAdded == true &&
        self.productsDetailCount > 0 &&
        !this.validarTiendaSeleccionada(self.current.tiendas_set)
      ) {
        this.refreshCurrent();
        this.errorsModals(
          "No se puede desasignar la tienda si hay al menos 1 producto asignado a la campaña."
        );
      } else {
        DynamicService.postAction(
          "cat",
          "campana-ofertas",
          self.current.id,
          "agregar_tienda",
          {
            tienda: item.codigo,
          }
        )
          .then((response) => {
            Notifications.toast.success(
              "Agregar o quitar tienda",
              "Se ha guardado la Información."
            );
            self.validacion();
          })
          .catch((error) => {
            self.currentDetalle.errors = error.response.data;
            if (error.response.data.detail) {
              Notifications.alert.error(
                "Agregar o quitar tienda",
                error.response.data.detail
              );
              self.refreshCurrent();
            }
          });
      }
    },

    /**
     * Funcion que nos guarda el array de las tiendas seleccionadas
     * en el Backend, cuando es el listado completo
     * 
     * @restrictive = parametro que nos permite dejar una tienda seleccionada
     * por defecto, en el caso de que haya al menos un producto asignado en la campaña.
     */
    addStoreListAction(restrictive) {
      let self = this;
      DynamicService.getAction(
        "cat",
        "campana-ofertas",
        self.current.id,
        "agregar_tienda_lista",
        {
          status: self.all_tiendas,
        }
      )
        .then((response) => {
          Notifications.toast.success(
            "Agregar o quitar todas las tiendas tienda",
            "Se ha guardado la Información."
          );
          if(restrictive===true) {
            let tiendas_array = self.current.tiendas_set[1];
            self.agregarDetalleTienda(tiendas_array);
            self.refreshCurrent();
          } else {
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.currentDetalle.errors = error.response.data;
          if (error.response.data.detail) {
            Notifications.alert.error(
              "Agregar o quitar todas las tiendas",
              error.response.data.detail
            );
            self.refreshCurrent();
          }
        });
    },

    agregarTodosTiendas() {
      let self = this;
      self.productosAddedCounter();
      if (self.productsDetailCount === 0 && self.isProductsAdded === false) {
        self.addStoreListAction();
      }
      if (
        self.isProductsAdded == true &&
        self.productsDetailCount > 0 &&
        self.validarTiendaSeleccionada(self.current.tiendas_set) == true
      ) {
        if (
          self.isProductsAdded == true &&
          self.productsDetailCount > 0 &&
          self.validarTodasLasTiendaSeleccionadas(self.current.tiendas_set) == true
        ) {
          self.addStoreListAction(true);
          this.errorsModals(
            "No se pueden desasignar todas las tiendas, si hay al menos 1 producto asignado a la campaña."
          );
        } else {
          self.addStoreListAction();
        }
      }
    },

    refreshDefault() {
      let self = this;
      self.currentDetalle.cantidad = 0;
      self.currentDetalle.precio = 0;
      self.currentDetalle.cantidad_minima = "";
      self.currentDetalle.unidad_medida = "";
      self.currentDetalle.producto = "";
    },

    refreshCurrent() {
      let self = this;
      DynamicService.getById(
        "cat",
        "campana-ofertas",
        this.$route.params.id
      ).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.usuario.name;
        self.current.fecha_fin = moment(
          response.data.fecha_fin,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
        self.fecha_fin_texto = self.current.fecha_fin;
        self.current.fecha_inicio = moment(
          response.data.fecha_inicio,
          "DD/MM/YYYY"
        ).format("YYYY-MM-DD");
        self.fecha_inicio_texto = self.current.fecha_inicio;
        self.current.fecha_creacion = moment(
          self.current.fecha_creacion
        ).format("DD/MM/YYYY hh:mm:s a");
        self.current.errors = [];
        self.productosAddedCounter();
        self.validacion();
        console.log(self.fecha_fin_texto , fecha_inicio_texto);
      });
    },

    validacion() {
      let self = this;
        "hay tiendas seleccionadas?: ",
        this.validarTiendaSeleccionada(self.current.tiendas_set)
      let d = self.current.tiendas_set.filter(function (det) {
        return det.seleccionada == true;
      });
      if (d[0]) {
        self.all_tiendas = true;
        self.isTiendaSelected = true;
      } else {
        self.all_tiendas = false;
        self.isTiendaSelected = false;
      }
    },

    guardar() {
      let self = this;
      let current = Object.assign({}, self.current);
      current.tienda = self.current.tienda;
      if (self.current.fecha_inicio) {
        current.fecha_inicio = moment(self.current.fecha_inicio).format(
          "DD/MM/YYYY"
        );
      }
      if (self.current.fecha_fin) {
        current.fecha_fin = moment(self.current.fecha_fin).format("DD/MM/YYYY");
      }
      DynamicService.save("cat", "campana-ofertas", current)
        .then((response) => {
          Notifications.alert.success(
            "Guardar campaña de ofertas",
            "Realizádo Exitosamente"
          );
          if (current.id == null) {
            self.$router.push({
              name: "cat-escalas-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          Notifications.alert.error(
            "Guardar campañas de ofertas",
            error.response.data.detail
          );
        });
    },
    actualizarFechaCampana(){
      let self=this;  
      let params = self.current

      DynamicService.postActionList("cat","campana-ofertas","actualizar_fechas_campana",params)
      .then((response)=>{        
        self.refreshCurrent()
        Notifications.alert.success("Actualizar fechas de campaña",    
        "Se actualizó las fechas de campaña exitosamente")
        self.cambiar_fecha_inicio=false,
        self.cambiar_fecha_fin=false
      }).catch((error)=>{
        Notifications.alert.error(
          "Actualizar fechas de campaña", 
          error.response.data.detail
        )        
      })
    },
    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar producto",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          DynamicService.postAction(
            "cat",
            "campana-ofertas",
            self.current.id,
            "eliminar_linea",
            {
              id: detalle.id,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Eliminar producto",
                "Se ha eliminado la Información."
              );
              self.productsDetailCount = self.productsDetailCount - 1;
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Eliminar producto",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Traslado",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          ReqTrasladoService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "¡Información Importante!",
        "Si cierra la requisicion no podra abrirla nuevamente",
        "Si cerrar",
        function () {
          ReqTrasladoService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Traslado",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          ReqTrasladoService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },

    //Inicio - calcular el porcentaje de descuento
    obtenerPreciosProductos(){
      let self = this;
      self.isPreciosProductosCargados = false;
      self.currentDetalle.unidad_medida = "";
      self.currentDetalle.precio="";

      return DynamicService.getById(
        "cat",
        "productos",
        self.currentDetalle.producto.sku,
      ).then ((response) =>{
        self.precios_de_productos = response.data.lista_precios;
        self.isPreciosProductosCargados = true;
        return response.data.lista_precio
      });
    },
    getProductoSeleccionado(lista){
        let self = this;

      if(!self.isPreciosProductosCargados || !lista){
          return null;
      }

      return self.precios_de_productos.find(producto =>
        producto.unidad_medida.id === self.currentDetalle.unidad_medida && producto.lista_precio.id === lista
      );
    },
    getPorcentajeNumerico(lista){
      let self = this;
      const producto = self.getProductoSeleccionado(lista);
      
      if(!producto || !producto.precio){
        return null;
      }

      self.actualizarPreciosPorLista(lista, producto.precio);

      const precioOriginal = producto.precio;
      const precioCampana = self.currentDetalle.precio;

      return parseFloat((((precioCampana -precioOriginal)/precioOriginal)*100).toFixed(1));
    },
    actualizarPreciosPorLista(lista, precio){
      let self = this;
      
      if (lista === 2){
        self.precios_x_lista.lista_2 = precio;
      }else if(lista ===15){
        self.precios_x_lista.lista_15= precio;
      }else if(lista === 19){
        self.precios_x_lista.lista_19= precio;
      }
    },
    calcularDescuento(lista){
      let self = this;
      if(!self.isPreciosProductosCargados){
        return "_"
      }
      if (!lista) {
        return "No lista";
      }

      if(!self.currentDetalle.unidad_medida){
        return "Selecciona um"
      }

      const porcentaje = self.getPorcentajeNumerico(lista);
      if (porcentaje === null) {
        return "No disponible";
      }
      return `${porcentaje}%`;
    },
    getClaseDescuento(lista){
      let self = this;

      const porcentaje = self.getPorcentajeNumerico(lista);

      if (porcentaje === null){
        return '';
      }

      return porcentaje < 0 ? 'descuento': 'aumento';
    },
    esAumento(lista){
      //sirve para saber si es aumento, descuento o se muestra texto
      let self = this;

        const porcentaje = self.getPorcentajeNumerico(lista);

        if(porcentaje > 0){
          return true;
        }else if(porcentaje < 0){
          return false;
        }
        else if (porcentaje === null){
          return null;
        }
         
      
    },
    //Fin - calcular el porcentaje de descuento

    //Inicia agregar Detalle y realizar validaciones//
    agregaDetalle() {
      this.obtenerProductoEnOfertas();
    },
    obtenerProductoEnOfertas(){
      let self = this;
      let params = { sku : self.currentDetalle.producto.sku};
      self.ofertasInfoText = "";
     
      DynamicService.getAction(
        "cat",
        "campana-ofertas",
        self.current.id,
        "obtener_productos_en_otras_ofertas",
        params
      )
      .then((res) => {
        self.ofertas_en_comun = res.data;
  
          if(self.ofertas_en_comun.ofertas && self.ofertas_en_comun.ofertas.length > 0){
              self.ofertasInfoText = self.ofertas_en_comun.ofertas
              .map(
                (oferta) => 
                `Campaña ${oferta.campana_id}, del ${oferta.fecha_inicio} al ${oferta.fecha_fin}`).join("\n");
            self.procesarAgregaDetalle();
          }
          else{
            self.procesarAgregaDetalle();
          }        
        })
      .catch((err) => {
          self.currentDetalle.errors = err.response.data;
          if(err.response.data.detail){
            Notifications.alert.error(
              "Obtener Datos",
              err.response.data.detail
            )
          }
          self.procesarAgregaDetalle();
        });
    },
    procesarAgregaDetalle() {
      let self = this;
      if (self.ofertasInfoText && self.ofertasInfoText.length > 0) {
        Notifications.alert.confirm(
          "Producto en otras Ofertas Activas",
           `El producto está agregado en otras ofertas:\n\n${self.ofertasInfoText}`,
          "¿Desea continuar?",
          function() {
            self.ejecutarAgregaDetalle();
          }
        );
      } else {
        self.ejecutarAgregaDetalle();
      }
    },
    ejecutarAgregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);

      if (det.producto) {
        det.producto = det.producto.sku;
        det.unidad_medida = self.currentDetalle.unidad_medida;

        DynamicService.postAction(
          "cat",
          "campana-ofertas",
          self.current.id,
          "agregar_producto",
          det
        )
          .then((response) => {
            Notifications.alert.success(
              "Agregar producto",
              "Se ha guardado la Información."
            );
            self.isProductsAdded = true;
            self.productsDetailCount = self.productsDetailCount + 1;
            self.refreshCurrent();
            self.refreshDefault();
          })
          .catch((error) => {
            self.currentDetalle.errors = error.response.data;
            if (error.response.data.detail) {
              Notifications.alert.error(
                "Agregar producto",
                error.response.data.detail
              );
            }
          });
      }
    },
    //Fin agregar Detalle y realizar validaciones//

    getTipoOfertas(){
      let self=this;     

      DynamicService.getActionList(
        "cat",
        "campana-ofertas",
        "get_tipo_ofertas",
        ""
      ).then((response)=>{        
        self.tipoOfertas = response.data;
      }).catch((error)=>{
        console.log("Error", error)
      })
    },
    cambiarFechaInicio(){
      let self=this;
      self.cambiar_fecha_inicio = true;      
    },
    cambiarFechaFin(){
      let self=this;
      self.cambiar_fecha_fin = true;      
    },
    regresarFecha(){
      let self=this;
      self.cambiar_fecha_inicio = false;
      self.cambiar_fecha_fin = false;      
    }
  },
};
</script>
<style>
  .icono-class{
    cursor: pointer;
    color: #898d92
  }
  .icono-class:hover{
    cursor:pointer;
    color: #000000;
  }

</style>

